import uuidv1 from 'uuid/v1';
import * as constants from './action-constants';

export const setMoreMenuOpen = ({ isOpen }) => ({
  type: constants.SET_MORE_MENU_OPEN,
  payload: isOpen
});

export const studioSelectRender = ({ renderId, slideDirection, disableSlideAnimation }) => ({
  type: constants.SELECT_RENDER,
  payload: { renderId, slideDirection, disableSlideAnimation }
});

export const studioClearRender = () => ({
  type: constants.CLEAR_RENDER
});

export const selectPDPTooltipProduct = ({ productId, hotSpotIdx }) => (dispatch, getState) => {
  dispatch({
    type: constants.SELECT_PDP_TOOLTIP_PRODUCT,
    payload: { productId, hotSpotIdx }
  });
};

export const selectViewMode = ({ mode }) => ({
  type: constants.SELECT_VIEW_MODE,
  payload: mode
});

export const toggleFullScreenRender = () => ({
  type: constants.TOGGLE_FULL_SCREEN_RENDER
});

export const selectDesignsFilter = (filter) => ({
  type: constants.SELECT_DESIGNS_FILTER,
  payload: filter
});

export const updateHotspotStatus = (status) => ({
  type: constants.UPDATE_HOTSPOT_STATUS,
  payload: status
});

export const setPanoramaViewerOpenFlag = (open, renderId) => ({
  type: constants.SET_PANORAMA_VIEWER_OPEN_FLAG,
  payload: {open, renderId}
});

export const setAllowSwipe = (allow) => ({
  type: constants.SET_ALLOW_SWIPE,
  payload: allow
});

export const setForceRenderOnDesignChange = (value) => ({
  type: constants.SET_FORCE_RENDER_ON_DESIGN_CHANGE,
  payload: value
});

export const setDesignNotification = ({ notification }) => ({
  type: constants.SET_DESIGN_NOTIFICATION,
  payload: {
    ...notification,
    uuid: uuidv1() // add unique notification identifier
  }
});

/**
 *  Sets the showMobileHotspots property to a new value and
 *  sets hasSeensMobileHotspots property to true
 */
export const setShowMobileHotspots = (showMobileHotspots) => ({
  type: constants.SET_SHOW_MOBILE_HOTSPOTS,
  payload: showMobileHotspots
});

export const setMobileHotspotsView = (mobileHotspotsView) => ({
  type: constants.SET_MOBILE_HOTSPOTS_VIEW,
  payload: mobileHotspotsView
});
